import React from "react";

import {
  Box,
  Button,
  Flex,
  IconMpFreeShipping,
  IconTrash,
  Image,
  Link,
  List,
  ListItem,
  Span,
  Truncate,
} from "@catchoftheday/cg-components";
import { currency } from "@catchoftheday/utilities";

import { MiniCartItem } from "../../../types/index";

export type ListItemProps = {
  items?: MiniCartItem[];
  onItemRemove?: (item: MiniCartItem) => void;
};

export const ListItems: React.FC<ListItemProps> = ({
  items = [],
  onItemRemove,
}) => {
  return items && items.length > 0 ? (
    <List m={0} itemSeparator="1px solid" type="none">
      {items?.length &&
        items.map((item, idx) => (
          <ListItem
            key={`${item.productName}-${idx}`}
            p="13px 16px"
            mb="0"
            borderBottom={idx != items.length - 1 ? "1px solid" : undefined}
            borderBottomColor="ui.borderColor"
          >
            <Flex justifyContent="space-between">
              <Flex>
                <Box border={1} borderColor="ui.borderColor" mr="8px" p={1}>
                  <Link
                    href={item.link}
                    tabIndex={-1}
                    data-tracking="header-app-mini-cart-item-image"
                  >
                    <Image
                      alt={item.productName}
                      src={item.imageSrc}
                      width="64px"
                      height="52px"
                      overflow="hidden"
                    />
                  </Link>
                </Box>
                <Box fontSize="xs" maxWidth="185px">
                  <Truncate>
                    <Link
                      href={item.link}
                      color="typography.text"
                      fontWeight={100}
                      data-tracking="header-app-mini-cart-item-name"
                    >
                      {item.productName}
                    </Link>
                  </Truncate>
                  <Box color="typography.text" mt="5px">
                    <Span fontSize="inherit">Qty: {item.quantity}x</Span>
                    {item.attributeValueText && (
                      <Span fontSize="inherit">
                        &nbsp;|&nbsp; {item.attributeName}:&nbsp;
                        {item.attributeValueText}
                      </Span>
                    )}
                  </Box>
                </Box>
              </Flex>
              <Box>
                <Box position="relative">
                  <Span
                    pr="8px"
                    fontWeight="semibold"
                    verticalAlign="middle"
                    mr="16px"
                  >
                    ${currency(item.rowTotalPrice).toString()}
                  </Span>
                  <Box position="absolute" top={-4} right={0}>
                    <Button
                      aria-label={`Remove ${item.productName}`}
                      sizeVariant="xs"
                      variant="plain"
                      p="1px"
                      pb="4px"
                      display="inline"
                      data-tracking="header-app-mini-cart-remove-item"
                      onClick={() => {
                        if (typeof onItemRemove == "function") {
                          onItemRemove(item);
                        }
                      }}
                    >
                      <IconTrash
                        cursor="pointer"
                        hoverColor="brand.secondary"
                        width="14px"
                        height="15px"
                        color="typography.subText"
                      />
                    </Button>
                  </Box>
                </Box>

                {item.freeShippingMarketPlace && (
                  <Box color="green" mt="5px" textAlign="right">
                    <IconMpFreeShipping
                      width="40px"
                      height="24px"
                      data-testid="cart-item-mp-freeshipping-icon"
                    />
                  </Box>
                )}

                {!item.freeShippingMarketPlace && item.freeShippingClubCatch && (
                  <Box color="onePass.primary" mt="5px" textAlign="right">
                    <IconMpFreeShipping
                      width="40px"
                      height="30px"
                      data-testid="cart-item-cc-freeshipping-icon"
                    />
                  </Box>
                )}
              </Box>
            </Flex>
          </ListItem>
        ))}
    </List>
  ) : null;
};

export default ListItems;
